<template>
    <div class="MaboutUs">
        <mt-navbar v-model="selected">
            <mt-tab-item id="1">橙蟹简介</mt-tab-item>
            <mt-tab-item id="2">橙蟹优势</mt-tab-item>
            <mt-tab-item id="3">企业资讯</mt-tab-item>
            <mt-tab-item id="4">加入我们</mt-tab-item>
            <mt-tab-item id="5">联系我们</mt-tab-item>
        </mt-navbar>

        <mt-tab-container v-model="selected">
            <mt-tab-container-item class="intro" id="1">
                <h3>橙蟹介绍</h3>
                <p>橙蟹企服是一家专注于第三方规范财务的服务平台，以知识培训、财务核算、预算管控、税收筹划及团队激励为切入点，通过代办、外包、顾问及招聘等服务，解决企业成长中各阶段问题。橙蟹顾问团队均来自于四大会计师事务所，在财务需求上见解独到。</p>
                <p>橙蟹秉承“规范财务标准，践行行业价值”的创办初心，积累500余家企业服务案例，涉及17个行业及领域，规范定义财务流程，智能管理每一笔账，深度挖掘数据价值。坚持以纯粹客观的第三方视角出发，帮助企业不断发现各个方面的潜在风险并提供全面定制化的财税解决方案。</p>

                <h3>橙蟹大事件</h3>
                <div class="bigNew">
                    <img src="../../assets/img/about－image－1.png" alt="">
                </div>

                <h3>企业文化</h3>
                <div class="culture">
                    <div>橙蟹精神:职业尊严永放光芒</div>
                    <div>企业愿景:中小微企业的信用交易平台</div>
                    <div>价值观: 真文化、人平等、事透明</div>
                    <div>服务宗旨:销售即交付、交付即销售</div>
                </div>

                <h3>背景介绍</h3>
                <p>橙蟹企服，是深圳市云石企业服务有限公司（以下简称“云石企业”）旗下品牌服务商。“云石企业”注册成立于2014年，除橙蟹企服，目前“云石企业”还拥有控股子公司3家。</p>
                <div class="bgIntro">
                    <div>
                        <img src="../../assets/img/about－image－2.png" alt="">
                    </div>
                    <div>
                        <img src="../../assets/img/about－image－3.png" alt="">
                    </div>
                    <div>
                        <img src="../../assets/img/about－image－4.png" alt="">
                    </div>
                </div>
            </mt-tab-container-item>

            <mt-tab-container-item class="advantage" id="2">
                <div class="selectCX">
                    <div class=""><img src="../../assets/img/about－image－5.png" alt=""></div>
                    <div class="word">
                        <h3>为什么要选择橙蟹？</h3>
                        <p>创始人石金文先生来自于前立信会计师事务所“最年轻”的合伙人。作为有使命感的会计人，创始人放弃了会计师事务所高薪的岗位，带着改变行业现状的初衷，与志同道合的财务顾问团队一起联合创办了橙蟹企服平台。橙蟹企服顾问团队来自前四大会计师事务所资深成员，多年躬耕于企业财税服务领域。</p>
                    </div>
                </div>

                <h2>我们经验丰富<p>已服务企业数量500+</p>
                </h2>
                <div class="jyPic">
                    <img src="../../assets/img/about－image－6.png" alt="">
                </div>

                <h2>客户口碑<p>用实力说话</p>
                </h2>
                <div class="praise" v-for="(item,i) in praiseList" :key="i">
                    <div>
                        <img :src="item.imgPath" alt="">
                    </div>
                    <p>{{item.word}}</p>
                </div>
            </mt-tab-container-item>

            <mt-tab-container-item id="3">
                <ul class="mui-table-view" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="20" infinite-scroll-immediate-check="false">
                    <li class="information" v-for="(item, index) in informationList" :key="index" @click="jump('/McompanyNewsDetail/' + item.companyNewsId)">
                        <div>
                            <img :src="url+item.companyNewsImg" alt="">
                        </div>
                        <div class="word">
                            <h4>{{item.title}}</h4>
                            <p>{{item.description}}</p>
                        </div>
                    </li>

                    <li class="more_loading" v-show="!queryLoading">
                        <p v-show="allLoaded">到底啦！！！</p>
                    </li>
                </ul>
            </mt-tab-container-item>
            <mt-tab-container-item id="4" class="join">
                <h2>投递简历至：hr@orancrab.com</h2>
                <div class="formTop">
                    <el-row>
                        <el-col :span="8">
                            <div class="">职位名称</div>
                        </el-col>
                        <el-col :span="8">
                            <div class="">职位类别</div>
                        </el-col>
                        <el-col :span="6">
                            <div class="">工作城市</div>
                        </el-col>
                    </el-row>
                </div>
                <div class="sfq">
                    <el-collapse v-model="joinName" accordion>
                        <el-collapse-item v-for="(item,i) in joinList" :key="item.joinUsId" :name="i">
                            <template slot="title">
                                <el-row>
                                    <el-col :span="8">
                                        <div class="mt">&nbsp;&nbsp;&nbsp;&nbsp;{{item.jobName}}</div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="mt">&nbsp;&nbsp;&nbsp;&nbsp;{{item.jobStyle}}</div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="mt">&nbsp;&nbsp;&nbsp;&nbsp;{{item.city}}</div>
                                    </el-col>
                                </el-row>
                            </template>
                            <div class="responsibility">
                                <el-row>
                                    <el-col :span="5">
                                        <div class="">岗位职责：</div>
                                    </el-col>
                                    <el-col :span="19">
                                        <div class="">
                                            <p v-for="(json, i) in item.jobStatement" :key="i">{{json}}</p>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                            <div class="require">
                                <el-row>
                                    <el-col :span="5">
                                        <div class="">岗位要求：</div>
                                    </el-col>
                                    <el-col :span="19">
                                        <div class="">
                                            <p v-for="(json, i) in item.jobRequirement" :key="i">{{json}}</p>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </mt-tab-container-item>

            <mt-tab-container-item id="5" class="relation">
                <el-row class="line">
                    <el-col :span="3">
                        <div class="lxPic"><img src="../../assets/img/about－image－24.png" alt=""></div>
                    </el-col>
                    <el-col :span="6">
                        <div class="jian">
                            <span>售前支持：</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="zhi">
                            400-777-1147
                        </div>
                    </el-col>
                </el-row>

                <el-row class="line">
                    <el-col :span="3">
                        <div class="lxPic"><img src="../../assets/img/about－image－25.png" alt=""></div>
                    </el-col>
                    <el-col :span="18">
                        <div class="jian">
                            <p>商务支持：chengxie@orancrab.com</p>
                            <p>顾问服务：chenzhan@orancrab.com</p>
                        </div>
                    </el-col>
                </el-row>

                <el-row class="line">
                    <el-col :span="3">
                        <div class="lxPic"><img src="../../assets/img/about－image－26.png" alt=""></div>
                    </el-col>
                    <el-col :span="7">
                        <div class="jian">
                            <p>官方新浪微博：</p>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="zhi">
                            <img src="../../assets/img/about－image－weibo.png" alt="">
                        </div>
                    </el-col>
                </el-row>

                <el-row class="line">
                    <el-col :span="3">
                        <div class="lxPic"><img src="../../assets/img/about－image－27.png" alt=""></div>
                    </el-col>
                    <el-col :span="6">
                        <div class="jian">
                            <p>官方微信：</p>
                        </div>
                    </el-col>
                    <el-col :span="13">
                        <div class="zhi">
                            <img src="../../assets/img/home－image－cx.png" alt="">
                            <img src="../../assets/img/home－image－cxyc.png" alt="">
                        </div>
                    </el-col>
                </el-row>

                <el-row class="line">
                    <el-col :span="3">
                        <div class="lxPic"><img src="../../assets/img/about－image－28.png" alt=""></div>
                    </el-col>
                    <el-col :span="6">
                        <div class="jian">
                            <p>总部地址：</p>
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <div class="zhi">
                            <p>广东省深圳市宝安区宝源路名优工业产品展示采购中心B座B738</p>
                            <div class="dt">
                                <img src="../../assets/img/about－image－29.png" alt="">
                            </div>
                        </div>
                    </el-col>
                </el-row>
				<el-row class="line">
                    <!-- <el-col :span="3">
                        <div class="lxPic"><img src="../../assets/img/about－image－28.png" alt=""></div>
                    </el-col> -->
                    <el-col :span="6" :offset="3">
                        <div class="jian">
                            <p>武汉地址：</p>
                        </div>
                    </el-col>
                    <el-col :span="18" :offset="3">
                        <div class="zhi">
                            <p>湖北省武汉市江汉区云霞路189号泛海创业中心7楼07-107</p>
                        </div>
                    </el-col>
                </el-row>
            </mt-tab-container-item>
        </mt-tab-container>
    </div>
</template>

<script>
    import { companyNews, joingetPageList } from "../../api/api.js";
    import { Indicator } from 'mint-ui';
    export default {
        name: 'MaboutUs',
        watch: {
            "$route": "getPath"
        },
        created() {
            this.selected = this.$route.params.selected
            companyNews({ isFore: 1 }).then(res => {
                this.informationList = res.data.data.list;
            });
            joingetPageList().then(res => {
                for (let i = 0; i < res.data.data.list.length; i++) {
                    if (res.data.data.list[i].joinUsStatus == '1') {
                        this.joinList.push(res.data.data.list[i])
                    }
                }
                for (let i = 0; i < this.joinList.length; i++) {
                    this.joinList[i].jobRequirement = this.joinList[i].jobRequirement.split('；');
                    this.joinList[i].jobStatement = this.joinList[i].jobStatement.split('；');
                }
            });
        },
        data() {
            return {
                url: this.GLOBAL.picURL,
                selected: '1',
                praiseList: [
                {
                    imgPath: require("../../assets/img/about－image－7.png"),
                    word: "橙蟹给我们提供非常不错的财务服务，在这之前我们使用的是传统的代理记账，收到的是一本糊涂账。自从和橙蟹合作以来，公司的账务非常清晰，还能在橙蟹的APP上随时查看员工实时报销的明细，我相信我以后再也不会碰以前的供应商了。"
                },
                {
                    imgPath: require("../../assets/img/about－image－8.png"),
                    word: "我们选择橙蟹作为财务外包服务商，有效的消减了成本，不仅节省了人力成本，还节省了大量的时间和精力，我们能真正将资源投放到公司的核心竞争力上，避免在我们并不擅长的财务环节花费太多精力。"
                },
                {
                    imgPath: require("../../assets/img/about－image－9.png"),
                    word: "我们选择橙蟹做财务外包服务，借用他们的专业优势来实现和挖掘我们企业的价值。这在公司创建初期，管理和人员配置还不够全面的情况下，选择靠谱的财务外包是最合适的方式。"
                },
                {
                    imgPath: require("../../assets/img/about－image－10.png"),
                    word: "让专业的人做专门的事，是能让企业利益最大化，以最低的成本获取更高品质、更专业的财务服务。这也弥补了我们企业缺乏财务方面高层次专业人才的缺陷，有助于提高我们企业的管理水平。"
                },
                {
                    imgPath: require("../../assets/img/about－image－11.png"),
                    word: "选择橙蟹，省事、省钱、省心，橙蟹专业、规范、执行力强，我们很放心！"
                },
                {
                    imgPath: require("../../assets/img/about－image－12.png"),
                    word: "我们公司有财务部，但还是购买了橙蟹的财务服务，包括记账报税等基础财务服务，还有财务顾问服务。他们每周定时上门，深入公司内部，了解我们现在的经营状况和未来的发展战略，从财务角度出发，为我们规划新产品的业务流程设计，和我们一起交流互联网产品开发需求，从业务源头开始提供财务规范、纳税筹划、融资方案等咨询。橙蟹对创业公司发展的卓知远见，为我们提供了很多专业的建议，公司的发展成长，离不开橙蟹的协助，感谢橙蟹的服务！"
                },
                {
                    imgPath: require("../../assets/img/about－image－13.png"),
                    word: "选择橙蟹是我们的幸运，因公司业务复杂，从公司成立就开始和橙蟹合作，最初起步就有了真正的管理账务，对于公司的融资起到了举足轻重的作用。低成本的同时得到了专业的财务咨询服务，对于初创的企业来说真的是物美价廉。非常感谢橙蟹一路的陪伴成长！"
                },
                {
                    imgPath: require("../../assets/img/about－image－14.png"),
                    word: "与橙蟹合作一年有余，站在管理的角度上讲为我们公司节省下了很多的精力，从而有更多的时间去专注于公司核心业务的发展。无论是在管理成本、报表质量、财务软件成本，还是在应对业务增长、实现规模效益、税务筹划、规避欺诈和违规风险方面，橙蟹的专业服务都比企业内部会计更占优势。所以选择橙蟹是比较明智的选择。"
                },
                {
                    imgPath: require("../../assets/img/about－image－15.png"),
                    word: "了解橙蟹是因为非常欣赏橙蟹坚持的真账理念，和我们公司的文化非常契合。橙蟹接手以后，帮我们重新梳理了以前的帐，认真核对每一笔流水，仔细分清楚每一个客户和供应商，也提供了很多规范管理的建议，现在的账务非常清晰准确，也非常及时。了解橙蟹是因为非常欣赏橙蟹坚持的真账理念，和我们公司的文化非常契合。橙蟹接手以后，帮我们重新梳理了以前的帐，认真核对每一笔流水，仔细分清楚每一个客户和供应商，也提供了很多规范管理的建议，现在的账务非常清晰准确，也非常及时。"
                },
                {
                    imgPath: require("../../assets/img/about－image－16.png"),
                    word: "最近公司的业务增长比较快，公司人手不足，财务工作全部交由橙蟹负责，我们无保留全力配合，大家合作的非常好，我们月初提供资料，橙蟹收到后5个工作日内给我们财务报表，每月15日之前完成。橙蟹给的管理建议推行有效，现在越来越规范，效率越来越高。预计明年我们的业务量会翻番，非常期待橙蟹为我们提供更多专业的服务，财务有橙蟹我们很放心！"
                },
                {
                    imgPath: require("../../assets/img/about－image－17.png"),
                    word: "9月份抱着尝试的心态购买了橙蟹一个季度的财务咨询业务，服务启动后超出我们期待。规范的财务管理体系可以增强我们未来的融资能力，橙蟹顾问专业、严谨，细致的指导让我们少走很多弯路，而且性价比极高，合作一个月我就推荐给我朋友公司了。"
                },
                {
                    imgPath: require("../../assets/img/about－image－18.png"),
                    word: "橙蟹帮我们整理旧账，梳理业务流程，写建议书帮我们规范资金、存货、单据管理。每个月上门提供财务报表解读，用平实易懂的方式分析我们最关心的‘钱从哪里来？钱花到哪里去？’橙蟹整理分析我们所有的经营数据，为我们的经营决策提供参考，每次交流会都获益匪浅。"
                },
                {
                    imgPath: require("../../assets/img/about－image－19.png"),
                    word: "橙蟹的财务顾问非常专业，合作以来，通过数据分析发现了我们经营中存在的很多问题和不足，目前已在他们的支持下采取了有效措施解决这些问题，我相信在橙蟹的陪伴下，我们未来的路会走的越来越好！"
                },
                {
                    imgPath: require("../../assets/img/about－image－20.png"),
                    word: "市面上真正能提供受托单位会计核算、税务筹划、纳税申报、内部审计、工商税务注册年检、财税咨询等全方位会计服务的机构很少。很幸运，找到橙蟹这家为创业者提供一站式服务的供应商，随着公司的发展，越来越感受到选择橙蟹的重要性，感谢橙蟹的服务！"
                },
                {
                    imgPath: require("../../assets/img/about－image－21.png"),
                    word: "我们只花了三分之一的人力成本，请了橙蟹这个专业团队来为我们做财务服务，降低了财务内置成本，提升了财务信息质量。由橙蟹这个独立的第三方机构来操作财务信息，可信度也更高，我们更容易被投资人、债权人以及政府机构的认可。和橙蟹的合作非常顺畅和愉快，感谢橙蟹的财务顾问合作以来给我们提供的服务！"
                }],
                joinName: [0],
                joinList: [],
                informationList: [],
                pageNum: 1,
                queryLoading: false,
                moreLoading: false,
                allLoaded: false,
            }
        },
        methods: {
            getPath() {
                console.log(this.$route.params)
                this.selected = this.$route.params.selected
            },
            loadMore() {
                if (this.selected == 3) {
                    if (this.allLoaded) {
                        this.moreLoading = true;
                        return;
                    }
                    if (this.queryLoading) {
                        return;
                    }
                    Indicator.open({
                        text: '加载中...',
                        spinnerType: 'fading-circle'
                    });
                    this.loading = true;
                    setTimeout(() => {
                        this.pageNum++;
                        companyNews({
                            pageNum: this.pageNum,
                            isFore: 1
                        }).then(res => {
                            for (let i = 0; i < res.data.data.list.length; i++) {
                                this.informationList.push(res.data.data.list[i])
                            }
                            Indicator.close();
                            this.allLoaded = this.informationList.length == res.data.data.total;
                            this.moreLoading = this.allLoaded;
                        })
                        this.loading = false;
                    }, 2500);
                }
            },
            jump(key) {
                this.$router.push({ path: key });
            }
        }
    }
</script>

<style lang="scss" scoped>
    // 橙蟹简介
    .intro {
        width: 96%;
        padding: 0 2% 8% 2%;

        h3 {
            text-align: center;
            font-weight: 900;
            font-size: 16px;
            padding: 4% 0;
            color: #2e324f;
        }

        p {
            font-size: 14px;
            text-indent: 2em;
            padding: 2% 0;
        }

        .bigNew {
            img {
                width: 100%;
            }
        }

        .culture {
            margin-top: 2%;

            div {
                display: inline-block;
                width: 46%;
                padding: 3% 0;
                margin-left: 2%;
                margin-bottom: 2%;
                text-align: center;
                background-color: #2d3557;
                color: #ffffff;
                font-size: 14px;
            }
        }

        .bgIntro {
            div {
                display: inline-block;
                width: 31.3333%;

                img {
                    width: 100%;
                }
            }
        }
    }

    // 橙蟹优势
    .advantage {
        padding-bottom: 4%;

        .selectCX {
            margin-top: 1%;

            div {
                display: inline-block;

                img {
                    width: 100%;
                }
            }

            .word {
                padding: 0 2% 4% 2%;

                h3 {
                    text-align: center;
                    font-size: 24px;
                    color: #2e324f;
                    padding: 2% 0;
                    ;
                }

                p {
                    text-indent: 2em;
                }
            }
        }

        h2 {
            text-align: center;
            font-size: 24px;
            margin: 3% 0;
            color: #2e324f;

            p {
                font-size: 14px;
                font-weight: normal;
            }
        }

        .jyPic {
            img {
                width: 100%;
            }
        }

        .praise {
            display: inline-block;
            width: 100%;
            text-align: center;
            padding: 4% 0;
            margin: 2% 0;
            background-color: #f5f5f5;

            img {
                width: 50%;
            }

            p {
                padding: 0 4%;
            }
        }
    }

    // 企业资讯
    .information {
        margin-top: 1%;

        div {
            padding: 0 2%;

            img {
                width: 100%;
            }

            h4 {
                color: #2d3557;
                font-size: 16px;
            }

            p {}
        }

        .word {
            background-color: #f5f5f5;
            margin: 0 2%;
            margin-bottom: 8%;
        }
    }

    .more_loading {
        p {
            text-align: center
        }
    }

    // 加入我们
    .join {
        .formTop {
            padding: 0 4%;
            font-size: 16px;
            font-weight: 900;

        }

        h2 {
            text-align: center;
            padding: 4% 0;
            padding-bottom: 8%;
            color: #2d3557;
        }

        .responsibility {
            padding: 0 4%;
            margin-bottom: 2%;
        }

        .require {
            padding: 0 4%;
        }
    }

    // 联系我们
    .relation {
        padding: 2% 4%;

        .line {
            margin-bottom: 4%;
        }

        .dt {
            img {
                width: 100%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/mobile/MaboutUs.vue